import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  Circle,
  NotificationContent,
  NotificationDescription,
  NotificationTitle,
  NotificationWrapper,
  StyledCircle,
} from './styled.notifications';

export function NotificationSkeleton () {
  const repeatCount = 10;
  return (
    <>
    {Array.from({ length: repeatCount }).map((_, index) => (
      <NotificationWrapper key={index}>
        <StyledCircle>
          <Circle>
            <Skeleton width={40} height={40} borderRadius={40} />
          </Circle>
        </StyledCircle>
        <NotificationContent>
          <NotificationTitle>
            <div>
              <Skeleton width={80} />
            </div>
            <div>
              <Skeleton width={80} />
            </div>
          </NotificationTitle>
          <NotificationDescription>
            <Skeleton width={350} />
            <Skeleton width={55} />
          </NotificationDescription>
        </NotificationContent>
      </NotificationWrapper>
    ))}
  </>
  );
}
